import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { BaseDetail } from 'projects/admin/src/app/classes/base-detail';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { DetailModes } from 'projects/admin/src/app/shared/constants';
import { ElementModel } from 'projects/core/src/lib/models/element.model';
import { ExerciseModel } from 'projects/core/src/lib/models/exercise.model';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-element-detail',
  templateUrl: './element-detail.component.html',
  styleUrls: ['./element-detail.component.scss']
})
export class ElementDetailComponent extends BaseDetail implements OnInit {

  public element: ElementModel = null;
  public exercise: ExerciseModel = null;
  public backRoute = ['/exercises'];

  protected identifier = 'element';

  constructor(
    protected router: Router,
    protected ui: UiService,
    protected helper: HelperService,
    protected transloco: TranslocoService,
    private api: ApiService,
    private route: ActivatedRoute,
    ) {
      super(ui, router, helper, transloco);
    }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (!params.id || !params.element) {
        this.router.navigate(this.backRoute);
      }
      const optional: any = {};
      if (params.hashed_id) {
        optional.hashed_id = params.hashed_id;
      }
      if (params.element === 'new') {
        this.setLoading();
        this.api.getModel('exercises', params.id, optional).subscribe({
          next: (result: any) => {
            this.setExercise(result.data);
            this.setInitialized(DetailModes.new);
          },
          error: (error: any) => {
            this.setFailed(error);
          }
        });
      } else if (params.element) {
        this.setLoading();
        forkJoin([
          this.api.getModel('exercises', params.id, optional),
          this.api.getModel('elements', params.element)
        ]).subscribe({
          next: (result: Array<any>) => {
            this.setExercise(result[0].data);
            this.element = new ElementModel().deserialize(result[1].data);
            this.tabIndex = parseInt(localStorage.getItem(this.identifier + '-tab-' + this.element.id), 10);
            this.setInitialized(DetailModes.edit);
          },
          error: (error: any) => {
            this.setFailed(error);
          }
        });
      }
    });
  }

  onTabChange(event: any): void {
    if (this.element !== null) {
      localStorage.setItem(this.identifier + '-tab-' + this.element.id, event.index);
    }
    this.ui.setFocus();
  }

  private setExercise(data: any): void {
    this.exercise = new ExerciseModel().deserialize(data);
    this.backRoute = ['/exercises', this.exercise.id.toString()];
  }

}
